var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 108.65 88.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#_3);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#_3-2);}.cls-5{mix-blend-mode:hard-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_3",
    x1: 54.32,
    y1: 8.01,
    x2: 54.32,
    y2: 62.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c0a8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#a483ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8e66e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7f51d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7544d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7240d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.32,
    y1: 67.93,
    x2: 54.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7240d3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7443d4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7b4dd6",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#875cd9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9772df",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ac8ee5",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#c5b1ed",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#e3d9f6",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_3-2",
    x1: 54.32,
    y1: 30.12,
    x2: 54.32,
    y2: 88.69,
    xlinkHref: "#_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.25 62.93 84.51 62.93 80.58 58.01 54.32 25.19 50.39 30.11 28.06 58.01 24.13 62.93 10.39 62.93 14.32 58.01 14.33 58.01 50.39 12.93 54.32 8.01 58.25 12.93 94.31 58.01 94.32 58.01 98.25 62.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.32,8l3.93,4.92L94.31,58h0l3.93,4.92H84.51L80.58,58,54.32,25.19l-3.93,4.92L28.06,58l-3.93,4.92H10.39L14.32,58h0L50.39,12.93,54.32,8m0-8-3.9,4.89L46.49,9.81,11.93,53h0l-1.51,1.88L6.49,59.81,0,67.93H26.54L28,66.05,32,61.13,54.3,33.24l0,0L76.68,61.14l3.93,4.91,1.5,1.88h26.54l-6.49-8.12-3.93-4.92L96.73,53h0L62.16,9.81,58.23,4.89,54.32,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "80.58 62.94 80.58 88.69 54.32 69.31 28.06 88.69 28.06 62.94 54.32 30.12 80.58 62.94"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.25 62.93 84.51 62.93 80.58 58.01 54.32 25.19 50.39 30.11 28.06 58.01 24.13 62.93 10.39 62.93 14.32 58.01 14.33 58.01 50.39 12.93 54.32 8.01 58.25 12.93 94.31 58.01 94.32 58.01 98.25 62.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.32,8l3.93,4.92L94.31,58h0l3.93,4.92H84.51L80.58,58,54.32,25.19l-3.93,4.92L28.06,58l-3.93,4.92H10.39L14.32,58h0L50.39,12.93,54.32,8m0-8-3.9,4.89L46.49,9.81,11.93,53h0l-1.51,1.88L6.49,59.81,0,67.93H26.54L28,66.05,32,61.13,54.3,33.24l0,0L76.68,61.14l3.93,4.91,1.5,1.88h26.54l-6.49-8.12-3.93-4.92L96.73,53h0L62.16,9.81,58.23,4.89,54.32,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "80.58 62.94 80.58 88.69 54.32 69.31 28.06 88.69 28.06 62.94 54.32 30.12 80.58 62.94"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolet);
export default __webpack_public_path__ + "static/media/Violet.d27da712dc78572e535799e3dff65822.svg";
export { ForwardRef as ReactComponent };